"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cssPrefixer = void 0;
const cssPrefixer = (prefix) => (name) => `${prefix}--${name}`;
exports.cssPrefixer = cssPrefixer;
